import React, { useState, useEffect } from "react";
import { Row, Col, Form, Input, Tag } from "antd";
import AddPhysicianModalWrapper from "../../../modal/AddPhysicianModalWrapper";
import styled from "styled-components";
import { capitalizeFirstLetter } from "../../../../utils/utils";

const FormContainer = styled.div`
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
  width: 100%;

  /* Scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }

  /* &::-webkit-scrollbar-track {
    background:rgb(138, 136, 136);
    border-radius: 10px;
  } */

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  .formDetail {
    border: 1px solid var(--border-color);
    height: 40px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: start;
    font-size: 17px;
    color: var(--primary-text-color);
    font-weight: 600;
  }
  .ant-form-item-label > label {
    color: var(--secondary-text-color) !important;
  }
  .subHeading {
    color: var(--secondary-text-color);
    font-size: 16px;
    font-weight: 600;
  }
  .data {
    color: var(--primary-text-color);
    font-size: 16px;
    font-weight: 600;
    border: 1px solid var(--border-color);
    border-radius: 7px;
    margin-top: 9px;
    min-height: 41px;
    max-height: 155px;
    display: flex;
    // align-items: center;
    justify-content: start;
    padding: 0 10px;
    // background-color: var(--border-color);
    overflow: auto;
    white-space: normal;
    text-overflow: ellipsis;
  }
`;

const ViewScriptDetails = ({
  isOpen,
  setOpen,
  title,
  subtitle,
  DataById,
}) => {
  const [form] = Form.useForm();

  return (
    <AddPhysicianModalWrapper
      show={isOpen}
      setShow={setOpen}
      title={
        <div className="row-flex flex-column">
          <h3 className="font-20 font-semibold text-primary mb-5">{title}</h3>
          <span className="font-15 text-secondry">{subtitle}</span>
        </div>
      }
      footer={null}
      width={620}
      keyClose={false}
      className="custom-detail-modal"
    >
      <Form form={form} layout="vertical" requiredMark="optional">
        <FormContainer>
          <Row gutter={[24, 16]}>
            <Col span={24}>
              <div className="subHeading">Title</div>
              <div className="data d-flex ">
                {capitalizeFirstLetter(DataById?.scriptTitle)}
              </div>
            </Col>

            <Col span={24}>
              <div className="subHeading">Content</div>
              <div className="data">
                {capitalizeFirstLetter(DataById?.scriptContent)}
              </div>
            </Col>
          </Row>
        </FormContainer>
      </Form>
    </AddPhysicianModalWrapper>
  );
};

export default ViewScriptDetails;
